module.exports = __webpack_public_path__ + "static/media/bgi-target-user@3x.947ab7ec.png";